import React from "react";
import styles from "./style/FeatureFlag.module.css";

// Define the LoadingIcon component to display when fetching data
export const LoadingIcon = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className={styles.loading_icon} />
      <p style={{ marginTop: ".5rem" }}>Fetching data...</p>
    </div>
  );
};
